import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateUserRole = ({
  churchId,
  isDenomination = false,
  denominationId,
  userId,
  role
}) => {
  return axios.patch(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/users/${userId}`,
    role
  );
};

export const useUpdateUserRole = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("users");

      setNotification({
        type: "success",
        message: "Role updated successfully!"
      });
    },
    ...config,
    mutationFn: updateUserRole
  });
};
